import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {CollapsableFieldset, CollapsableFieldsetConfig} from "./collapsable_fieldset";

export const collapsableFieldsetLoader = function (options = {}) {
    componentLoader(componentConfig(CollapsableFieldset, CollapsableFieldsetConfig.componentTypeKey, CollapsableFieldsetConfig.baseHtmlClass), options);
};
